export const errorStatusMessage = {
  defaultMessage: 'Error',
  1: `Not enough money on the balance`,
  3: 'Exceeded the maximum bet limit per round',
};
